import { render, staticRenderFns } from "./stock-summary.vue?vue&type=template&id=421b5a26"
import script from "./stock-summary.vue?vue&type=script&lang=js"
export * from "./stock-summary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421b5a26')) {
      api.createRecord('421b5a26', component.options)
    } else {
      api.reload('421b5a26', component.options)
    }
    module.hot.accept("./stock-summary.vue?vue&type=template&id=421b5a26", function () {
      api.rerender('421b5a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CustomerViews/Stock/stock-summary.vue"
export default component.exports